<ng-container *ngIf="ready && content && content.length">
  <ng-container *ngFor="let item of content; let order = index">
    <app-content-accordion
      *ngIf="item.type === 'accordion'"
      [item]="item.content"
    ></app-content-accordion>
    <app-content-animation
      *ngIf="item.type === 'animation'"
      [item]="item.content"
    ></app-content-animation>
    <app-content-button
      *ngIf="item.type === 'button'"
      [item]="item.content"
    ></app-content-button>
    <app-content-form
      *ngIf="item.type === 'form'"
      [item]="item.content"
    ></app-content-form>
    <app-content-image
      *ngIf="item.type === 'image'"
      [item]="item.content"
    ></app-content-image>
    <app-content-input
      *ngIf="item.type === 'input'"
      [item]="item.content"
    ></app-content-input>
    <app-content-link
      *ngIf="item.type === 'link'"
      [item]="item.content"
    ></app-content-link>
    <app-content-paragraph
      *ngIf="item.type === 'paragraph'"
      [item]="item.content"
    ></app-content-paragraph>
    <app-content-tabs
      *ngIf="item.type === 'tabs'"
      [item]="item.content"
    ></app-content-tabs>
    <app-content-text
      *ngIf="item.type === 'text'"
      [item]="item.content"
    ></app-content-text>
    <app-content-video
      *ngIf="item.type === 'video'"
      [item]="item.content"
    ></app-content-video>
    <app-content-spacer
      *ngIf="item.type === 'spacer'"
      [item]="item.content"
    ></app-content-spacer>
    <app-content-multiselect
      *ngIf="item.type === 'multiselect'"
      [item]="item.content"
    ></app-content-multiselect>
    <app-content-flow
      *ngIf="item.type === 'flow'"
      [item]="item.content"
    ></app-content-flow>
    <app-content-card
      *ngIf="item.type === 'card'"
      [item]="item.content"
    ></app-content-card>
    <app-training-tip
      *ngIf="item.type === 'tip'"
      [item]="item.content"
    ></app-training-tip>
  </ng-container>
</ng-container>
